export default __webpack_public_path__ + "static/media/crime.5bce08d3.jpg";